import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentNotification, setCurrentNotification] = useState({
    name: '',
    city: ''
  });
  const maleNames = ['Juan', 'Carlos', 'Diego', 'Martín', 'Pablo', 'Fernando', 'Rodrigo', 'Javier', 'Sebastián', 'Matías', 'Marcelo', 'Gustavo', 'Hernán', 'Alejandro', 'Nicolás', 'Andrés', 'Federico'];
  const femaleNames = ['María', 'Laura', 'Ana'];
  const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'Santa Fe', 'Mar del Plata', 'Salta', 'Neuquén', 'Bahía Blanca', 'La Plata', 'San Juan'];
  const getRandomNotification = () => {
    const isMale = Math.random() < 0.85;
    const nameList = isMale ? maleNames : femaleNames;
    const randomName = nameList[Math.floor(Math.random() * nameList.length)];
    const randomCity = cities[Math.floor(Math.random() * cities.length)];
    return {
      name: randomName,
      city: randomCity
    };
  };
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      setCurrentNotification(getRandomNotification());
      setIsVisible(true);
    }, 30000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (isVisible) {
      const hideTimer = setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      return () => clearTimeout(hideTimer);
    } else {
      const showTimer = setTimeout(() => {
        setCurrentNotification(getRandomNotification());
        setIsVisible(true);
      }, Math.random() * 10000 + 15000);
      return () => clearTimeout(showTimer);
    }
  }, [isVisible]);
  return <AnimatePresence data-id="element-173">
      {isVisible && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-6 left-6 z-50 bg-gray-800 border-2 border-green-600 rounded-lg shadow-2xl p-4 max-w-sm" data-id="element-174">
          <div className="flex items-start gap-3" data-id="element-175">
            <CheckCircleIcon className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-176" />
            <div data-id="element-177">
              <p className="text-white font-semibold" data-id="element-178">
                {currentNotification.name} de {currentNotification.city}
              </p>
              <p className="text-gray-300 text-sm" data-id="element-179">
                acaba de comprar Sistema Ciclista 360™
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}